// @ts-nocheck
/* eslint-disable */

'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
exports.StyledLabelsContainer = exports.StyledBarIndicator = exports.StyledProgressBarContainer = void 0;

var _styledComponents = _interopRequireWildcard(require('../../styled-components'));

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};
    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc =
            Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};
          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }
    newObj.default = obj;
    return newObj;
  }
}

function _templateObject4() {
  var data = _taggedTemplateLiteral([
    '\n    display: flex;\n    width: 100%;\n    align-items: baseline;\n    padding-top: ',
    ';\n    justify-content: ',
    '\n'
  ]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral([
    '\n    width: ',
    '%;\n    height: ',
    ';\n    background-color: ',
    ';\n    border-radius: ',
    ';\n    animation: ',
    ' 1s ease-in-out forwards;\n'
  ]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(['\n    background-color: ', ';\n    border-radius: ', ';\n']);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral([
    '\n        from {\n            width: 0;\n        }\n        to {\n            width: ',
    '%;\n        }\n    '
  ]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } }));
}

var ProgressAnimation = function ProgressAnimation(props) {
  return (0, _styledComponents.keyframes)(_templateObject(), props.value);
};

var StyledProgressBarContainer = _styledComponents.default.div.withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return !['containerColor', 'radius'].includes(prop);
  }
})(
  _templateObject2(),
  function (props) {
    return props.containerColor || props.theme.colors.secondaryBrand3;
  },
  function (props) {
    return props.radius || props.theme.graphs.barGauge.radius;
  }
);

exports.StyledProgressBarContainer = StyledProgressBarContainer;

var StyledBarIndicator = _styledComponents.default.div.withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return !['value', 'height', 'backgroundColor', 'radius'].includes(prop);
  }
})(
  _templateObject3(),
  function (props) {
    return props.value;
  },
  function (props) {
    return props.height || props.theme.graphs.barGauge.height;
  },
  function (props) {
    return props.backgroundColor;
  },
  function (props) {
    return props.radius || props.theme.graphs.barGauge.radius;
  },
  function (props) {
    return ProgressAnimation(props);
  }
);

exports.StyledBarIndicator = StyledBarIndicator;

var StyledLabelsContainer = _styledComponents.default.div.withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return !['labelPaddingTop', 'justifyLabels'].includes(prop);
  }
})(
  _templateObject4(),
  function (props) {
    return props.labelPaddingTop || '5px';
  },
  function (props) {
    return props.justifyLabels;
  }
);

exports.StyledLabelsContainer = StyledLabelsContainer;
